import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	loading: false,
	order: null,
	meta: {}
};

export default function receiptPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_ORDER_BY_ORDER_ID_REQUEST:
		case ActionTypes.GET_ORDER_BY_ORDER_ID_ERROR:
		case ActionTypes.GET_ORDER_BY_ORDER_ID_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_RECEIPT_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
